// extracted by mini-css-extract-plugin
export default {"map":"IceCreamMap_map__tnIL1"};